/*
   Merch Quote — teklif ürünü için ürün detay sayfası adet paneli

   Merch Studio'nun konfigüratöründen ayrı duruyor. Oradaki kontrolcü çok ürünlü
   bir katalog, tasarım adımı ve 5 görünüm üzerine kurulu; burada tek ürün, tek
   renk. Ortak olan yalnızca fiyat motoru: kademe tablosu
   + USD/TRY kuru, o da merch-price.js'te tek kopya duruyor — üç yerde (ürün
   detay, sepet, drawer) aynı adette aynı fiyatın çıkması için.

   KİŞİSELLEŞTİRME (Baskı / Nakış)
   Ayrı Shopify ürünleri; modelin `personalisations` alanında bağlı. Seçilince
   sepete ek satır olarak giriyor ve ADEDİ BU RENGİN TEKLİFTEKİ TOPLAM ADEDİ:
   XS 15 + S 15 + M 15 + L 15 → 60 baskı. Renk başına tek yöntem; panel
   sepetteki seçimi önceden işaretliyor, farklı yöntemle eklenince eskisi
   kalkıyor. Sonradan sepette adet değişirse eşitlemeyi merch-quote-cart.js
   yapıyor — buradaki adet yalnızca ilk ekleme anının doğrusu.
*/
(function () {
  'use strict';

  /* Fiyat motoru merch-price.js'te. Uc yerde (urun detay, sepet, drawer)
     ayni sayinin cikmasi gerekiyor; kopyalanmis uygulamalarda biri
     degistiginde digerleri sessizce farkli fiyat gosterirdi. */
  var P = window.MerchPrice;
  if (!P) {
    console.error('[merch-quote] merch-price.js yuklenmedi; fiyat hesaplanamaz.');
    return;
  }
  var round2 = P.round2;
  var money = P.money;
  var usdMoney = P.usdMoney;
  var priceFor = P.priceFor;

  function S(key, fallback) {
    var s = window.mqStrings || {};
    return s[key] || fallback;
  }

  /* ------------------------------------------------------------------ */

  function MerchQuote(root) {
    this.root = root;
    this.data = null;
    this.qty = {};
    this.busy = false;
    /* Seçili kişiselleştirme ürününün id'si; 0 = yok. Kullanıcı dokunana
       kadar sepetteki durumu yansıtıyor (persoTouched). */
    this.perso = 0;
    this.persoTouched = false;
  }

  MerchQuote.prototype.init = function () {
    var tag = this.root.querySelector('[data-mq-data]');
    if (!tag) return false;
    try {
      this.data = JSON.parse(tag.textContent);
    } catch (e) {
      console.error('[merch-quote] Ürün verisi çözümlenemedi.', e);
      return false;
    }
    if (!this.data.sizes || !this.data.sizes.length) return false;

    if (!this.data.ladder) {
      /* Fiyat tablosu yoksa sayfa yine çalışsın — adet toplanır, fiyat
         "teklifte" kalır. Sessizce 0 TL göstermek daha kötü olurdu. */
      console.warn('[merch-quote] Bu ürün için fiyat kademesi yok (' +
        (this.data.handle || '?') + '). Tema ayarı → Merch Studio → ' +
        'Tipe göre fiyat kademesi altına ürün tipini ekleyin.');
    }

    this.el = {
      panel: this.root.querySelector('[data-mq-panel]'),
      grid: this.root.querySelector('[data-mq-grid]'),
      moq: this.root.querySelector('[data-mq-moq]'),
      totals: this.root.querySelector('[data-mq-totals]'),
      perso: this.root.querySelector('[data-mq-perso]'),
      add: this.root.querySelector('[data-mq-add]'),
      error: this.root.querySelector('[data-mq-error]')
    };

    /* Merchant "Minimum order {moq} pieces" yazabilsin: sayiyi iki yere
       (tema ayari + metin) elle girmek, biri degisince digerinin sessizce
       yanlis kalmasi demek. */
    if (this.el.moq && this.el.moq.textContent.indexOf('{moq}') >= 0) {
      this.el.moq.textContent =
        this.el.moq.textContent.split('{moq}').join(String(this.moq()));
    }

    /* Kişiselleştirme ÖNCE: seçim sepetten okunuyor ve beden çizimi
       toplamları hesaplarken o seçimi kullanıyor. */
    this.renderPerso();
    this.renderSizes();
    this.bind();
    return true;
  };

  /* ------------------------------------------------- kişiselleştirme */

  MerchQuote.prototype.persoOptions = function () {
    return (this.data.personalisation || []).filter(function (o) {
      return o && o.variantId && o.ladder;
    });
  };

  MerchQuote.prototype.persoLabel = function (o) {
    var kinds = S('persoKinds', {}) || {};
    return kinds[o.kind] || o.title;
  };

  MerchQuote.prototype.selectedPerso = function () {
    var self = this;
    var list = this.persoOptions();
    for (var i = 0; i < list.length; i++) {
      if (list[i].productId === self.perso) return list[i];
    }
    return null;
  };

  /* Sepette BU RENGE bağlı kişiselleştirme satırları. Bağ satırın kendi
     property'sinde (`_merch_addon_for` = ürün id), çünkü aynı Baskı ürünü
     birden çok rengin satırında ayrı ayrı duruyor. */
  MerchQuote.prototype.persoInCart = function () {
    var sepet = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!sepet || !sepet.items) return [];
    var hedef = String(this.data.id);
    return sepet.items.filter(function (i) {
      return i.properties && i.properties._merch_addon_for === hedef;
    }).map(function (i) {
      return { key: i.key, productId: i.product_id, quantity: i.quantity };
    });
  };

  /* Kullanıcı seçime dokunmadıysa sepetteki durumu göster: bu renkte zaten
     baskı varken panelin "Yok" diye açılması, bir sonraki eklemede baskının
     sessizce kalkması demek olurdu. */
  MerchQuote.prototype.persoFromCart = function () {
    if (this.persoTouched) return;
    var ids = this.persoOptions().map(function (o) { return o.productId; });
    var sepette = this.persoInCart().filter(function (e) {
      return ids.indexOf(e.productId) >= 0;
    });
    this.perso = sepette.length ? sepette[0].productId : 0;
  };

  MerchQuote.prototype.persoUnit = function (o) {
    return priceFor(o.ladder, this.data.fx.rate, 1);
  };

  MerchQuote.prototype.renderPerso = function () {
    var box = this.el.perso;
    if (!box) return;
    var self = this;
    var list = this.persoOptions();
    if (!list.length) { box.hidden = true; box.innerHTML = ''; return; }

    this.persoFromCart();
    box.hidden = false;
    box.innerHTML = '';

    var set = document.createElement('fieldset');
    set.className = 'mq-perso__set';
    var legend = document.createElement('legend');
    legend.className = 'mq-perso__legend';
    legend.textContent = S('persoLegend', 'Personalisation');
    set.appendChild(legend);

    var opts = document.createElement('div');
    opts.className = 'mq-perso__opts';
    var ad = 'mq-perso-' + this.data.id;

    function secenek(id, name, sub) {
      var lab = document.createElement('label');
      lab.className = 'mq-perso__opt' + (self.perso === id ? ' is-selected' : '');

      var input = document.createElement('input');
      input.type = 'radio';
      input.className = 'mq-perso__radio';
      input.name = ad;
      input.value = String(id);
      input.checked = self.perso === id;
      input.addEventListener('change', function () {
        if (!input.checked) return;
        self.perso = id;
        self.persoTouched = true;
        Array.prototype.forEach.call(opts.children, function (c) {
          c.classList.toggle('is-selected', c === lab);
        });
        self.renderTotals();
      });

      var top = document.createElement('span');
      top.className = 'mq-perso__top';
      var n = document.createElement('span');
      n.className = 'mq-perso__name';
      n.textContent = name;
      var dot = document.createElement('span');
      dot.className = 'mq-perso__dot';
      dot.setAttribute('aria-hidden', 'true');
      top.appendChild(n);
      top.appendChild(dot);

      var s = document.createElement('span');
      s.className = 'mq-perso__price';
      s.textContent = sub;

      lab.appendChild(input);
      lab.appendChild(top);
      lab.appendChild(s);
      opts.appendChild(lab);
    }

    secenek(0, S('persoNone', 'None'), S('persoNoneSub', 'Blank garment'));
    list.forEach(function (o) {
      var p = self.persoUnit(o);
      secenek(o.productId, self.persoLabel(o),
        p ? S('persoPerPc', '+{price} / pc').replace('{price}', money(p.unitTry))
          : S('atQuote', 'At quote'));
    });

    set.appendChild(opts);

    var hint = document.createElement('p');
    hint.className = 'mq-perso__hint';
    hint.setAttribute('data-mq-perso-hint', '');
    hint.setAttribute('aria-live', 'polite');
    set.appendChild(hint);

    box.appendChild(set);
    this.renderPersoHint();
  };

  /* Açıklama adede göre değişiyor: "60 adedin tamamına" cümlesi müşterinin
     baskının neden 60 adet geleceğini sepette görmeden anlamasını sağlıyor.
     Sayıya sepetteki adet de katılıyor — ek satır rengin TOPLAMINA eşitleniyor. */
  MerchQuote.prototype.renderPersoHint = function () {
    var hint = this.root.querySelector('[data-mq-perso-hint]');
    if (!hint) return;
    var sel = this.selectedPerso();
    if (!sel) {
      hint.textContent = S('persoHintNone',
        'Add your logo with print or embroidery. Artwork and placement are agreed with our team.');
      return;
    }
    var n = this.inCartTotal() + this.totalUnits();
    var ad = this.persoLabel(sel);
    hint.textContent = n > 0
      ? S('persoHintOn', '{method} is applied to all {n} pieces of this colour in your quote.')
          .replace('{method}', ad).replace('{n}', n)
      : S('persoHintOnEmpty', '{method} is applied to every piece of this colour in your quote.')
          .replace('{method}', ad);
  };

  /* Bu eklemedeki adet için kişiselleştirme tutarı (panel tahmini). */
  MerchQuote.prototype.persoQuote = function (units) {
    var sel = this.selectedPerso();
    if (!sel || !units) return null;
    var p = priceFor(sel.ladder, this.data.fx.rate, units);
    return { option: sel, units: units, unitUsd: p ? p.unitUsd : null,
             unitUsdGross: p ? p.unitUsdGross : null,
             unitTry: p ? p.unitTry : null, total: p ? p.total : null };
  };

  MerchQuote.prototype.moq = function () {
    return this.data.moq || 0;
  };

  /**
   * Bir bedenin FIYATA SAYILAN adedi. Stok sinirini asan giris 0 sayiliyor.
   *
   * Once ham deger kullaniliyordu: musteri XL'e 11100 yazinca kutu kirmiziya
   * donuyordu ama toplam satirlarinda "XL x 11100" ve ona gore hesaplanmis bir
   * kademe fiyati ile genel toplam gorunuyordu. Siparis edilemeyecek bir sey
   * icin fiyat gostermek yaniltici; uzerine kademe fiyati da yanlis banda
   * kayiyordu (11140 adet -> $13.22) ve dogru adede donuldugunde fiyat
   * "artiyormus" gibi duruyordu.
   *
   * overCap() bilerek HAM degere bakiyor: burasi da ondan turerse asim hic
   * tespit edilemezdi.
   */
  MerchQuote.prototype.qtyOf = function (v) {
    var n = this.qty[v.size] || 0;
    var cap = this.capOf(v);
    if (cap !== null && n > cap) return 0;
    return n;
  };

  MerchQuote.prototype.totalUnits = function () {
    var self = this, t = 0;
    this.data.sizes.forEach(function (v) { t += self.qtyOf(v); });
    return t;
  };

  /*
     SEPETTEKİ ADET DE STOKTAN DÜŞÜYOR

     Shopify stoğu ancak sipariş verilince azaltıyor; sepette bekleyen teklif
     satırları `inventory_quantity` değerini değiştirmiyor. Bu yüzden panel
     stoğun tamamını ikinci kez teklif edilebilir gibi gösteriyordu ve
     "Teklife ekle" Shopify'ın "The maximum quantity of this item is already
     in your cart" hatasıyla dönüyordu — hem de ancak butona basınca.

     Teklif sepeti günlerce dolu kalabildiği için bu istisna değil, olağan
     durum. Tavan artık KALAN adet: stok eksi sepetteki.
  */
  MerchQuote.prototype.inCart = function (v) {
    var sepet = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!sepet || !sepet.items) return 0;
    var n = 0;
    sepet.items.forEach(function (i) {
      if (i.variant_id === v.id) n += i.quantity;
    });
    return n;
  };

  /* Stok sınırı yalnızca tema ayarı açıkken uygulanıyor. Kapalıyken cap
     gösterilmiyor bile: "maks. 0" yazıp girişi kilitlemek, stoğu henüz
     yüklenmemiş üründe akışı tamamen durdururdu. */
  MerchQuote.prototype.capOf = function (v) {
    if (!this.data.enforceStock) return null;
    if (typeof v.cap !== 'number') return null;
    return Math.max(v.cap - this.inCart(v), 0);
  };

  /* Sepetteki TOPLAM adet (bu ürün değil, sepetin tamamı): kısmi eklemeyi
     anlamak için ekleme öncesi/sonrası karşılaştırılıyor. */
  MerchQuote.prototype.cartCount = function () {
    var c = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    return c && typeof c.item_count === 'number' ? c.item_count : 0;
  };

  /* Bu ürünün sepette duran toplam adedi — "stok yok" ile "hepsi sizde"
     ayrımını yapabilmek için. */
  MerchQuote.prototype.inCartTotal = function () {
    var self = this, t = 0;
    this.data.sizes.forEach(function (v) { t += self.inCart(v); });
    return t;
  };

  MerchQuote.prototype.totalCap = function () {
    if (!this.data.enforceStock) return Infinity;
    var t = 0;
    for (var i = 0; i < this.data.sizes.length; i++) {
      var c = this.capOf(this.data.sizes[i]);
      if (c === null) return Infinity;
      t += Math.max(c, 0);
    }
    return t;
  };

  MerchQuote.prototype.renderSizes = function () {
    var self = this;
    var grid = this.el.grid;
    if (!grid) return;
    grid.innerHTML = '';

    /* Toplam stok MOQ'ya yetmiyorsa hiçbir kombinasyon geçerli olamaz;
       kutuları doldurtup butonu sessizce kapalı tutmak yerine baştan kapalı. */
    /* MİNİMUM SİPARİŞ SEPETTEKİYLE BİRLİKTE DEĞERLENDİRİLİYOR
       Müşterinin teklifinde bu renkten 91 adet varken bir beden daha
       eklemek için 50 adet DAHA istemek yanlış: sipariş 92 adet olacak,
       minimum çoktan aşılmış. Kilit ancak sepettekiyle kalan stoğun toplamı
       bile minimuma yetmiyorsa anlamlı — o zaman hiçbir kombinasyon
       geçerli olamaz ve kutuları doldurtmak boşuna. */
    var unreachable = (this.inCartTotal() + this.totalCap()) < this.moq();

    this.data.sizes.forEach(function (v, i) {
      var cell = document.createElement('div');
      cell.className = 'mq-size';
      cell.setAttribute('data-mq-cell', String(i));

      var label = document.createElement('span');
      label.className = 'mq-size__label';
      label.textContent = v.size;
      cell.appendChild(label);

      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'numeric';
      input.autocomplete = 'off';
      input.className = 'mq-size__input';
      input.setAttribute('aria-label', v.size);
      input.value = self.qty[v.size] || '';

      var cap = self.capOf(v);
      var kapali = unreachable || (cap !== null && cap <= 0) ||
        (self.data.enforceStock && !v.available);

      if (kapali) {
        /*
          Kutu ÜÇ ayrı sebeple kapanabiliyor ve üçüne de "Stok yok" yazmak
          yanlış yönlendiriyordu:
            1. Beden gerçekten tükenmiş     -> yapılacak bir şey yok
            2. Stoğun tamamı zaten sepette  -> sepetten çıkarınca yer açılır
            3. Panel toptan kilitli (kalan toplam MOQ'nun altında) -> bu
               bedende stok olabilir; sebep MOQ satırında yazıyor, burada
               kalan adedi göstermek daha doğru
        */
        var stokYok = self.data.enforceStock && !v.available;
        var hepsiSepette = !stokYok && typeof v.cap === 'number' &&
          v.cap > 0 && self.inCart(v) >= v.cap;

        if (stokYok || (cap !== null && cap <= 0 && !hepsiSepette)) {
          input.placeholder = S('outOfStock', 'Sold out');
        } else if (hepsiSepette) {
          input.placeholder = S('inCart', 'In quote');
        } else {
          input.placeholder = cap !== null ? S('maxShort', 'max') + ' ' + cap : '0';
        }
        input.disabled = true;
        cell.classList.add('is-empty');
      } else {
        input.placeholder = cap !== null ? S('maxShort', 'max') + ' ' + cap : '0';
      }

      input.addEventListener('input', function () {
        var n = parseInt(String(input.value).replace(/\D/g, ''), 10) || 0;
        self.qty[v.size] = n;
        input.value = n || '';
        self.validate();
        self.renderTotals();
      });

      cell.appendChild(input);

      var msg = document.createElement('span');
      msg.className = 'mq-size__msg';
      msg.setAttribute('data-mq-msg', String(i));
      cell.appendChild(msg);

      grid.appendChild(cell);
    });

    this.validate();
    this.renderTotals();
  };

  MerchQuote.prototype.overCap = function () {
    var self = this, list = [];
    this.data.sizes.forEach(function (v) {
      var cap = self.capOf(v);
      if (cap !== null && (self.qty[v.size] || 0) > cap) list.push(v);
    });
    return list;
  };

  MerchQuote.prototype.validate = function () {
    var self = this;

    this.data.sizes.forEach(function (v, i) {
      var cell = self.root.querySelector('[data-mq-cell="' + i + '"]');
      var msg = self.root.querySelector('[data-mq-msg="' + i + '"]');
      if (!cell || !msg) return;
      var cap = self.capOf(v);
      var over = cap !== null && (self.qty[v.size] || 0) > cap;
      cell.classList.toggle('is-error', over);
      msg.textContent = over
        ? S('maxStock', 'Up to {n} pieces for this size').replace('{n}', cap)
        : '';
    });

    var total = this.totalUnits();
    var moq = this.moq();

    if (this.el.moq) {
      var el = this.el.moq;
      if (el.getAttribute('data-mq-moq-default') === null) {
        el.setAttribute('data-mq-moq-default', el.textContent);
      }
      var cap = this.totalCap();
      var sepette = this.inCartTotal();
      var sepetliMetin = S('mostlyInQuote',
        '{n} pieces of this colour are already in your quote; {k} left.')
        .replace('{n}', sepette).replace('{k}', cap).replace('{moq}', moq);

      if (sepette + cap < moq) {
        /* Hiçbir kombinasyon minimuma ulaşamıyor. "Bu renkte yalnızca 2 adet
           stok var" demek, adedin müşterinin KENDİ teklifinde duruyorken
           yanlış: stok yerinde, müşteri onu kendisi tüketmiş. İlki başka
           renge, ikincisi sepeti düzenlemeye yönlendiriyor. */
        el.textContent = sepette > 0
          ? sepetliMetin
          : S('stockBelowMoq', 'Only {n} pieces in stock, minimum order is {moq}.')
              .replace('{n}', cap).replace('{moq}', moq);
        el.classList.add('is-warn');
      } else if (sepette > 0) {
        /* Minimuma ulaşılabiliyor; cümle uyarı değil bilgi. Kutuların çoğu
           neden kilitli sorusunun cevabı da burada. Uyarı rengine ancak
           girilen adet sepettekiyle birlikte bile minimumu bulmuyorsa
           geçiyor. */
        el.textContent = sepetliMetin;
        el.classList.toggle('is-warn', total > 0 && (total + sepette) < moq);
      } else {
        el.textContent = el.getAttribute('data-mq-moq-default');
        el.classList.toggle('is-warn', total > 0 && total < moq);
      }
    }

    /* `total > 0` şart: sepette minimumu karşılayacak kadar ürün varken
       hiçbir şey girilmeden butonun açılması anlamsız olurdu. */
    var ok = total > 0 && (total + this.inCartTotal()) >= moq && !this.overCap().length;
    if (this.el.add) this.el.add.disabled = !ok || this.busy;
    return ok;
  };

  MerchQuote.prototype.quote = function () {
    var total = this.totalUnits();
    if (!total) return { units: 0, unitUsd: null, unitTry: null, total: 0 };
    var p = priceFor(this.data.ladder, this.data.fx.rate, total);
    if (!p) return { units: total, unitUsd: null, unitTry: null, total: 0 };
    return { units: total, unitUsd: p.unitUsd, unitUsdGross: p.unitUsdGross, unitTry: p.unitTry, total: p.total };
  };

  MerchQuote.prototype.renderTotals = function () {
    /* Kişiselleştirme açıklaması adedi söylüyor; adet her değiştiğinde
       toplamlarla birlikte tazeleniyor. */
    this.renderPersoHint();

    var box = this.el.totals;
    if (!box) return;
    box.innerHTML = '';

    var q = this.quote();
    if (!q.units) return;
    var pq = this.persoQuote(q.units);

    var self = this;
    function row(label, value, sub, cls) {
      var r = document.createElement('div');
      r.className = 'mq-total' + (cls ? ' ' + cls : '');
      var l = document.createElement('span');
      l.className = 'mq-total__label';
      l.textContent = label;
      var v = document.createElement('span');
      v.className = 'mq-total__value';
      v.textContent = value;
      r.appendChild(l);
      r.appendChild(v);
      if (sub) {
        var s = document.createElement('span');
        s.className = 'mq-total__sub';
        s.textContent = sub;
        r.appendChild(s);
      }
      box.appendChild(r);
    }

    /* Beden satırları: her variant ayrı yazılıyor çünkü sepete de ayrı satır
       olarak gidiyor — Shopify variant başına tek satır tutuyor. */
    this.data.sizes.forEach(function (v) {
      var n = self.qtyOf(v);
      if (!n) return;
      row(
        v.size + ' × ' + n,
        q.unitTry != null ? money(round2(q.unitTry * n)) : S('atQuote', 'At quote')
      );
    });

    if (q.unitTry != null) {
      row(
        S('lineUnit', 'Unit price'),
        money(q.unitTry),
        usdMoney(q.unitUsdGross) + '/' + S('unitShort', 'pc') +
          ' · ' + q.units + ' ' + S('lineTier', 'pcs tier')
      );
    }

    /* Kişiselleştirme ayrı satır: "Baskı × 60" müşterinin sepette göreceği
       ek satırın aynısı. Alt satır birim fiyatı iki para biriminde veriyor,
       ürün birim satırıyla aynı kalıpta. */
    if (pq) {
      row(
        this.persoLabel(pq.option) + ' × ' + pq.units,
        pq.total != null ? money(pq.total) : S('atQuote', 'At quote'),
        pq.unitTry != null
          ? money(pq.unitTry) + '/' + S('unitShort', 'pc') + ' · ' +
            usdMoney(pq.unitUsdGross) + '/' + S('unitShort', 'pc')
          : null
      );
    }

    /* Kişiselleştirme seçiliyse toplam artık yalnızca ürün değil; "(ürün)"
       etiketi o zaman yanlış olurdu. Parçalardan biri fiyatlanamıyorsa
       kısmi bir rakam yazmak yerine "Teklifte". */
    var tamam = q.unitTry != null && (!pq || pq.total != null);
    row(
      pq ? S('lineGrandAll', 'Estimated total') : S('lineGrand', 'Estimated total (product)'),
      tamam ? money(round2(q.total + (pq ? pq.total : 0))) : S('atQuote', 'At quote'),
      null,
      'mq-total--grand'
    );
  };

  MerchQuote.prototype.bind = function () {
    var self = this;

    if (this.el.add) {
      this.el.add.addEventListener('click', function () { self.addToCart(); });
    }
  };

  MerchQuote.prototype.fail = function (mesaj) {
    if (!this.el.error) return;
    this.el.error.textContent = mesaj;
    this.el.error.hidden = false;
  };

  MerchQuote.prototype.addToCart = function () {
    if (this.busy || !this.validate()) return;

    var self = this;
    var q = this.quote();
    var items = [];

    this.data.sizes.forEach(function (v) {
      var n = self.qtyOf(v);
      if (!n) return;
      /* Alt çizgiyle başlayan property sepet arayüzünde gizli kalıyor ama
         Liquid'den okunabiliyor — "Request a quote" butonunu tetikleyen işaret
         bu. Fiyat bilgisi de yazılıyor: sepetteki satır Shopify'ın perakende
         fiyatını gösteriyor, teklif fiyatı kademeden geliyor ve ikisi farklı. */
      items.push({
        id: v.id,
        quantity: n,
        properties: {
          _merch_quote: 'true',
          _quote_size: v.size,
          _quote_unit_usd: q.unitUsd != null ? String(round2(q.unitUsd)) : '',
          _quote_unit_try: q.unitTry != null ? String(q.unitTry) : '',
          _quote_tier_qty: String(q.units),
          _quote_fx: String(self.data.fx.rate),
          _quote_fx_date: self.data.fx.date || ''
        }
      });
    });

    if (!items.length) return;

    /*
       KİŞİSELLEŞTİRME SATIRI
       Hedef adet = bu rengin teklifteki TOPLAMI (sepetteki + şimdi eklenen).
       Aynı yöntem bu renk için zaten sepetteyse Shopify aynı property'li
       satırı birleştirip adedi ÜSTÜNE ekliyor; o yüzden yalnızca fark
       gönderiliyor. Farklı yöntemdeki eski satır(lar) başarıdan sonra
       kaldırılıyor: renk başına tek yöntem. "Yok" seçilip eklenirse de
       kalkıyor — panel sepetteki seçimi önceden işaretlediği için bu ancak
       müşteri bilerek "Yok"a geçtiğinde olur.
    */
    var sel = this.selectedPerso();
    var mevcut = this.persoInCart();
    var kaldir = mevcut.filter(function (e) { return !sel || e.productId !== sel.productId; });
    if (sel) {
      var hedef = this.inCartTotal() + q.units;
      var ayni = mevcut.filter(function (e) { return e.productId === sel.productId; });
      var ayniAdet = ayni.reduce(function (t, e) { return t + e.quantity; }, 0);
      var ekAdet = hedef - ayniAdet;
      if (ekAdet > 0) {
        items.push({
          id: sel.variantId,
          quantity: ekAdet,
          properties: {
            _merch_quote: 'true',
            _merch_addon: sel.kind,
            _merch_addon_for: String(this.data.id)
          }
        });
      }
    }

    if (!window.liquidAjaxCart || typeof window.liquidAjaxCart.add !== 'function') {
      this.fail(S('cartError', 'Could not add to your quote. Please refresh and try again.'));
      return;
    }

    this.busy = true;
    this.el.add.disabled = true;
    /* Ekran okuyucu icin: gorsel spinner'in sozel karsiligi */
    this.el.add.setAttribute('aria-busy', 'true');
    this.root.classList.add('is-busy');
    if (this.el.error) this.el.error.hidden = true;

    /*
       KISMİ EKLEME
       Shopify bazen istenenden AZINI ekleyip hata döndürüyor: "Only 50 items
       were added to your cart due to availability". Liquid'de görünen
       `inventory_quantity` ile sepetin kabul ettiği adet her zaman aynı
       olmuyor — stoğun bir kısmı başka siparişlerde ayrılmış olabiliyor.
       Panel bunu önceden bilemez, sadece isteği yaptıktan sonra öğrenir.

       Eski davranış bunu tam başarısızlık sayıyordu: kırmızı hata, panel
       açık, adetler duruyor — ama ürünler sepete girmişti. Müşteri sayfayı
       yenileyene kadar göremiyor, tekrar denediğinde bu kez "zaten
       sepetinizde" hatası alıyordu.

       Artık sepet gerçekten büyüdüyse bu başarı sayılıyor. Kaç adet
       eklendiğini Shopify'ın kendi mesajı söylüyor, temanın bildirim balonu
       onu zaten gösteriyor.
    */
    var oncekiAdet = this.cartCount();

    function basarili() {
      /* Eklenen adetler sıfırlanıyor: panel hep açık, sıfırlanmasa kullanıcı
         aynı adetleri ikinci kez ekleyebiliyor ve fark etmiyor. */
      self.qty = {};
      /* Seçim artık sepetin kendisi; panel bundan sonra oradan okusun. */
      self.persoTouched = false;
      kaldir.forEach(function (e) {
        window.liquidAjaxCart.change({ id: e.key, quantity: 0 });
      });
      self.renderSizes();
      document.body.classList.add('js-show-ajax-cart');
    }

    window.liquidAjaxCart.add({ items: items }, {
      lastCallback: function (requestState) {
        self.busy = false;
        self.el.add.removeAttribute('aria-busy');
        self.root.classList.remove('is-busy');

        var ok = requestState && requestState.responseData && requestState.responseData.ok;
        if (ok) { basarili(); return; }

        var body = requestState && requestState.responseData && requestState.responseData.body;
        var mesaj = (body && (body.description || body.message)) ||
          S('cartError', 'Could not add to your quote. Please refresh and try again.');

        function basarisiz() { self.fail(mesaj); self.validate(); }

        /*
           Hata dönen istekte kütüphane iki şeyi birden atlıyor: sepet
           durumunu tazelemiyor VE bölümleri yeniden basmıyor (ikisi de
           `responseData.ok` şartına bağlı). Kısmi ekleme olup olmadığını
           anlamak için durumu biz çekiyoruz.

           `get` DEĞİL `update` kullanılıyor: kütüphane bölüm isteğini
           yalnızca gövdesi olan çağrılara ekliyor, `get`in gövdesi yok.
           `get` ile sepet sayısı doğruluyordu ama drawer eski (boş) haliyle
           açılıyordu — ürünler ancak sayfa yenilenince görünüyordu.
        */
        var L = window.liquidAjaxCart;
        if (!L || typeof L.update !== 'function') { basarisiz(); return; }

        L.update({}, { lastCallback: function () {
          if (self.cartCount() > oncekiAdet) basarili();
          else basarisiz();
        } });
      }
    });
  };

  /* ------------------------------------------------------------------ */

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-mq]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-mq-ready') === 'true') return;
      var mq = new MerchQuote(root);
      /* Sepet değişince yeniden çizebilmek için örneği kök öğede tutuyoruz. */
      if (mq.init()) { root.__mq = mq; root.setAttribute('data-mq-ready', 'true'); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Customizer'da blok düzenlenince section yeniden basılıyor; dinlemezsek
     panel ölü kalıyor ve merchant "çalışmıyor" diye geri dönüyor. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });

  /* Kalan stok sepete bağlı olduğu için sepet her değiştiğinde beden
     kutuları yeniden çiziliyor. `init` de dinleniyor: sayfa açılırken sepet
     durumu panelden SONRA yükleniyor ve ilk çizimde tavan eksik kalıyordu. */
  function tazele() {
    var roots = document.querySelectorAll('[data-mq][data-mq-ready="true"]');
    Array.prototype.forEach.call(roots, function (root) {
      if (!root.__mq) return;
      root.__mq.renderPerso();
      root.__mq.renderSizes();
    });
  }
  document.addEventListener('liquid-ajax-cart:init', tazele);
  document.addEventListener('liquid-ajax-cart:request-end', tazele);
})();
